import { filterTemplates } from 'common/api/templates';

import {
    FETCH_TEMPLATES,
    FETCH_TEMPLATES_FAILURE,
    FETCH_TEMPLATES_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

export default (branchOffice) => (dispatch) => {
    dispatch(actions[FETCH_TEMPLATES]());

    filterTemplates({ branchOffice })
        .then((response) => {
            dispatch(actions[FETCH_TEMPLATES_SUCCESS](response.data.data));
        })
        .catch((error) =>
            dispatch(
                actions[FETCH_TEMPLATES_FAILURE](error?.response?.data?.errors),
            ),
        );
};
